(function(window,document){
  'use strict';
  if(window.__jrPremiumUX)return;
  window.__jrPremiumUX=true;

  var MOBILE=window.matchMedia('(max-width:989px)');
  var SEARCH_KEY='jrx_last_property_search';
  var BOOKING=(window.JRX_CONFIG&&window.JRX_CONFIG.booking)||'https://calendly.com/jasjeetsinghrealty/private-real-estate-consultation?utm_source=shopify&utm_medium=website&utm_campaign=consultation';
var ATTR_KEYS=['gclid','gbraid','wbraid','msclkid','fbclid','utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
var ATTR_STORE_KEY='jrx_ad_attribution';
function captureAttribution(){try{var q=new URLSearchParams(location.search),found={},has=false;ATTR_KEYS.forEach(function(k){var v=q.get(k);if(v){found[k]=v;has=true;}});if(has)sessionStorage.setItem(ATTR_STORE_KEY,JSON.stringify(found));}catch(e){}}
function getAttribution(){try{return JSON.parse(sessionStorage.getItem(ATTR_STORE_KEY)||'{}');}catch(e){return {};}}
function applyAttribution(href){try{var attr=getAttribution();if(!Object.keys(attr).length)return href;var u=new URL(href,location.origin);Object.keys(attr).forEach(function(k){u.searchParams.set(k,attr[k]);});return u.toString();}catch(e){return href;}}
function patchCalendlyLinks(){try{all('a[href*="calendly.com"]').forEach(function(a){var href=a.getAttribute('href')||'';if(!/calendly\.com/i.test(href))return;var patched=applyAttribution(href);if(patched!==href)a.setAttribute('href',patched);});}catch(e){}}
captureAttribution();

  function read(key){try{return JSON.parse(localStorage.getItem(key)||'null');}catch(e){return null;}}
  function validRecent(item){return !!(item&&Date.now()-Number(item.time||0)<30*24*60*60*1000);}
  function esc(value){return String(value==null?'':value).replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c];});}
  function roots(){
    var list=[document],seen=[];
    function walk(root){
      if(!root||seen.indexOf(root)>-1)return;seen.push(root);
      try{root.querySelectorAll('*').forEach(function(node){if(node.shadowRoot){list.push(node.shadowRoot);walk(node.shadowRoot);}});}catch(e){}
    }
    walk(document);return list;
  }
  function all(selector){var out=[];roots().forEach(function(root){try{out=out.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));}catch(e){}});return out;}


  function findAcrossRoots(selector){
    var found=null;roots().some(function(root){try{found=root.querySelector(selector);}catch(e){}return !!found;});return found;
  }

  function honorHash(){
    var hash=String(location.hash||'');if(!hash||hash==='#')return;
    var target=findAcrossRoots(hash);if(!target)return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    try{target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});}catch(e){target.scrollIntoView();}
  }

  function internalSearchUrl(){
    var item=read(SEARCH_KEY);
    if(!validRecent(item)||!item.intent)return '/pages/property-search#live-search';
    var i=item.intent||{},u=new URL('/pages/property-search',location.origin);
    u.searchParams.set('q',i.location||i.raw||'Calgary, AB');
    u.searchParams.set('province','AB');u.searchParams.set('market','residential');u.searchParams.set('residential','1');u.searchParams.set('status','sale');u.searchParams.set('transaction','sale');
    u.searchParams.set('sort',item.sort||'6-D');
    if(i.type&&i.type!=='any')u.searchParams.set('property_type',i.type);
    if(i.beds)u.searchParams.set('beds',i.beds);if(i.baths)u.searchParams.set('baths',i.baths);
    if(i.min)u.searchParams.set('min',i.min);if(i.max)u.searchParams.set('max',i.max);
    if(i.keywords)u.searchParams.set('keywords',i.keywords);if(i.mls)u.searchParams.set('mls',i.mls);
    if(item.view)u.searchParams.set('view',item.view);if(item.sqft)u.searchParams.set('min_sqft',item.sqft);if(item.year)u.searchParams.set('year',item.year);
    u.hash='live-search';return u.pathname+u.search+u.hash;
  }

  function icon(kind){
    if(kind==='search')return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10.5 3a7.5 7.5 0 1 0 4.73 13.32L20.9 22l1.1-1.1-5.68-5.67A7.5 7.5 0 0 0 10.5 3Zm0 2a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Z"/></svg>';
    if(kind==='value')return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 9 7v13h-7v-7h-4v7H3V9l9-7Zm0 2.5L5 10v10h3v-7h8v7h3V10l-7-5.5Zm-3 3.7h6v2H9v-2Z"/></svg>';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 2v2H5.5A2.5 2.5 0 0 0 3 6.5v13A2.5 2.5 0 0 0 5.5 22h13a2.5 2.5 0 0 0 2.5-2.5v-13A2.5 2.5 0 0 0 18.5 4H17V2h-2v2H9V2H7Zm11.5 6H5.5V6.5h13V8Z"/></svg>';
  }

  function syncMobileBar(){
    var bar=document.querySelector('.jrx-mbar');if(!bar)return false;
    bar.setAttribute('aria-label','Primary actions');
    var links=bar.querySelectorAll('a');if(links.length<3)return false;
  bar.innerHTML='<a href="#" data-jrx-top="1" data-jrx-track="scroll_top"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V6"/><path d="M6 11l6-6 6 6"/></svg><span>Top</span></a><a href="/pages/about" data-jrx-track="about_open"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.6 9.2a2.4 2.4 0 1 1 3.4 2.2c-.8.4-1 .8-1 1.6"/><circle cx="12" cy="16.6" r=".7" fill="currentColor" stroke="none"/></svg><span>About</span></a><a href="/pages/buyers" data-jrx-track="services_open"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l9-7 9 7"/><path d="M5 9.6V20h14V9.6"/></svg><span>Services</span></a><a href="'+internalSearchUrl()+'" data-jrx-track="property_search_open"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg><span>Search</span></a><a href="/pages/contact" data-jrx-track="contact_open"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.4 3.6a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg><span>Contact</span></a>';
  var _t=bar.querySelector('[data-jrx-top]');if(_t)_t.addEventListener('click',function(e){e.preventDefault();try{(document.scrollingElement||document.documentElement).scrollTo({top:0,behavior:'smooth'});}catch(_){window.scrollTo(0,0);}});
    return true;
  }

  function installMobileStart(){
    var nav=document.getElementById('ghNav');if(!nav||nav.querySelector('.jr-mobile-start'))return;
    var li=document.createElement('li');li.className='jr-mobile-start';li.setAttribute('role','none');
    li.innerHTML='<span class="jr-mobile-start__eyebrow">Start Here</span><div class="jr-mobile-start__grid">'+
      '<a href="'+esc(internalSearchUrl())+'" data-jrx-track="property_search_open">'+icon('search')+'<span>Search Homes</span></a>'+
      '<a href="/pages/home-value#valuation-start" data-jrx-track="home_value_open" data-jr-intent="seller">'+icon('value')+'<span>Home Value</span></a>'+
      '<a href="'+esc(BOOKING)+'" data-jrx-track="schedule" data-jr-intent="general">'+icon('book')+'<span>Book</span></a></div>'+
      '<p class="jr-mobile-start__note">Calgary · Airdrie · Chestermere · Cochrane</p>';
    nav.insertBefore(li,nav.firstChild);
  }

  function improveField(field){
    if(!field||field.dataset.jrUxReady==='1')return;field.dataset.jrUxReady='1';
    var key=(field.name+' '+field.id+' '+field.type).toLowerCase();
    if(field.type==='email'||/email/.test(key)){field.setAttribute('inputmode','email');field.setAttribute('autocomplete',field.getAttribute('autocomplete')||'email');field.setAttribute('autocapitalize','none');field.setAttribute('spellcheck','false');}
    else if(field.type==='tel'||/phone|mobile|tel/.test(key)){field.setAttribute('inputmode','tel');field.setAttribute('autocomplete',field.getAttribute('autocomplete')||'tel');}
    else if(/postal|zip/.test(key)){field.setAttribute('inputmode','text');field.setAttribute('autocomplete',field.getAttribute('autocomplete')||'postal-code');field.setAttribute('autocapitalize','characters');}
    else if(/address/.test(key)){field.setAttribute('autocomplete',field.getAttribute('autocomplete')||'street-address');}
    else if(/first.?name/.test(key)){field.setAttribute('autocomplete',field.getAttribute('autocomplete')||'given-name');}
    else if(/last.?name/.test(key)){field.setAttribute('autocomplete',field.getAttribute('autocomplete')||'family-name');}
    else if(/name/.test(key)){field.setAttribute('autocomplete',field.getAttribute('autocomplete')||'name');}
    if(field.tagName==='INPUT'&&['text','search','email','tel','number'].indexOf(field.type)>-1)field.setAttribute('enterkeyhint','next');
  }

  function bindForm(form){
    if(!form||form.dataset.jrUxForm==='1')return;form.dataset.jrUxForm='1';
    Array.prototype.forEach.call(form.querySelectorAll('input,select,textarea'),improveField);
    form.addEventListener('invalid',function(event){
      var field=event.target;if(!field||field.dataset.jrUxInvalidHandled==='1')return;field.dataset.jrUxInvalidHandled='1';
      setTimeout(function(){delete field.dataset.jrUxInvalidHandled;try{field.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});field.focus({preventScroll:true});}catch(e){}},40);
    },true);
    form.addEventListener('submit',function(){
      if(!form.checkValidity())return;form.classList.add('jr-ux-submitting');form.setAttribute('aria-busy','true');
      setTimeout(function(){form.classList.remove('jr-ux-submitting');form.removeAttribute('aria-busy');},9000);
    });
  }

  function injectShadowFormCSS(root){
    if(!root||!root.host||root.querySelector('[data-jr-premium-ux-shadow]'))return;
    var style=document.createElement('style');style.setAttribute('data-jr-premium-ux-shadow','');
    style.textContent='@media(max-width:989px){form input:not([type=checkbox]):not([type=radio]),form select,form textarea{font-size:16px!important;min-height:48px}form button[type=submit],form input[type=submit]{min-height:50px;touch-action:manipulation}.jr-ux-submitting button[type=submit],.jr-ux-submitting input[type=submit]{opacity:.72!important;pointer-events:none!important}}';
    root.appendChild(style);
  }

  function scan(){
    syncMobileBar();installMobileStart();
    roots().forEach(function(root){if(root!==document)injectShadowFormCSS(root);try{root.querySelectorAll('form').forEach(bindForm);root.querySelectorAll('input,select,textarea').forEach(improveField);}catch(e){}});
patchCalendlyLinks();
  }

  document.addEventListener('click',function(event){
    var a=event.target&&event.target.closest?event.target.closest('.jrx-mbar a,.jr-mobile-start a'):null;if(!a)return;
    var href=a.getAttribute('href')||'';
    if(href==='/pages/property-search#live-search'||/\/pages\/property-search/.test(href)){href=internalSearchUrl();a.setAttribute('href',href);}
    try{
      var url=new URL(href,location.origin);
      if(url.origin===location.origin&&url.pathname===location.pathname&&url.hash){
        var target=findAcrossRoots(url.hash);if(target){event.preventDefault();history.replaceState({},'',url.hash);honorHash();}
      }
    }catch(e){}
  },true);

  function boot(){scan();honorHash();[120,400,900,1800,3500].forEach(function(t){setTimeout(function(){scan();honorHash();},t);});
    try{var pending=false,mo=new MutationObserver(function(){if(pending)return;pending=true;setTimeout(function(){pending=false;scan();},80);});mo.observe(document.documentElement,{childList:true,subtree:true});setTimeout(function(){mo.disconnect();},10000);}catch(e){}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  window.addEventListener('pageshow',scan);MOBILE.addEventListener&&MOBILE.addEventListener('change',scan);
})(window,document);

/* JR-COMM-0902: Communities cascading menu (homepage only).
   Mirrors the reference site IA: Level 1 = short list, Level 2 = area groups,
   Level 3 = the communities in that area. Residential-only searches.
   L2/L3 panels copy the theme dropdown styles at runtime so colours always match. */
(function(){
  var RES="detached,apartment,row-townhouse,full-duplex,multi-family";
  function U(n,city){ var p="/pages/property-search?q="+encodeURIComponent(city?n+", AB":n);
    if(city) p+="&cities="+encodeURIComponent(n);
    return p+"&property_type="+encodeURIComponent(RES)+"&min=0&max=100000000&sort=6-D&view=gallery"; }
  var G=[["Southeast",["Auburn Bay","Belvedere","Chaparral","Copperfield","Cranston","Douglasdale","Hotchkiss","Legacy","Logan Landing","Mahogany","McKenzie Lake","McKenzie Towne","New Brighton","Ogden","Rangeview","Riverbend","Seton","Sundance","Walden","Wolf Willow"],0],["Northwest",["Ambleton","Arbour Lake","Bowness","Brentwood","Cambrian Heights","Capitol Hill","Carrington","Charleswood","Citadel","Collingwood","Dalhousie","Edgemont","Glacier Ridge","Greenwood","Hamptons","Haskayne","Hawkwood","Hillhurst","Montgomery","Mount Pleasant","Parkdale","Ranchlands","Rockland Park","Rocky Ridge","Rosemont","Royal Vista","Sage Hill","Scenic Acres","Silver Springs","St. Andrews Heights","Sunnyside","Tuscany","University District","University Heights","Valley Ridge","Varsity","West Hillhurst"],0],["Southwest",["Altadore","Alpine Park","Aspen Woods","Bankview","Bayview","Bel Aire","Belmont","Braeside","Bridlewood","Britannia","Canyon Meadows","Cedarbrae","Chinook Park","Christie Park","Cliff Bungalow","Coach Hill","Cougar Ridge","Crestmont","Currie Barracks","Discovery Ridge","Eagle Ridge","Elbow Park","Elboya","Erlton","Evergreen","Garrison Woods","Glamorgan","Glenbrook","Glendale","Haysboro","Kelvin Grove","Killarney","Kingsland","Lakeview","Lincoln Park","Mayfair","Meadowlark Park","Millrise","Mount Royal","North Glenmore Park","Oakridge","Palliser","Parkhill","Patterson","Pine Creek","Pump Hill","Richmond","Rideau Park","Rosscarrock","Roxboro","Rutland Park","Scarboro","Shaganappi","Shawnee Slopes","Shawnessy","Signal Hill","Silverado","Somerset","South Calgary","Southwood","Springbank Hill","Spruce Cliff","Strathcona Park","Sunalta","West Springs","Westgate","Wildwood","Windsor Park","Woodbine","Woodlands"],0],["South",["Acadia","Bonavista Downs","Deer Ridge","Deer Run","Diamond Cove","Fairview","Lake Bonavista","Maple Ridge","Midnapore","Parkland","Queensland","Willow Park","Yorkville"],0],["North",["Beddington","Country Hills","Coventry Hills","Evanston","Harvest Hills","Hidden Valley","Huntington Hills","Kincora","Livingston","MacEwan Glen","Nolan Hill","Sandstone Valley","Sherwood","Thorncliffe"],0],["Northeast",["Cityscape","Cornerstone","Homestead","Keystone Hills","Martindale","Redstone","Saddle Ridge","Skyview Ranch","Taradale"],0],["Inner City",["Banff Trail","Beltline","Bridgeland","Crescent Heights","Downtown West End","Eau Claire","East Village","Greenview","Highfield","Highland Park","Highwood","Inglewood","Lower Mount Royal","Marda Loop","Mission","Ramsay","Renfrew","Rosedale","Tuxedo Park","Winston Heights"],0],["Surrounding Cities",["Airdrie","Chestermere","Cochrane","Okotoks","Strathmore","High River"],1]];
  function esc(s){ return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;"); }
  function build(){
    var h='<ul class="jrcm2 jrcm2--l1"><li class="jrcm2__has"><button type="button" class="jrcm2__t">Calgary Neighbourhoods<span class="jrcm2__c">&#8250;</span></button><ul class="jrcm2 jrcm2--l2">';
    G.forEach(function(g){
      h+='<li class="jrcm2__has"><button type="button" class="jrcm2__t">'+esc(g[0])+'<span class="jrcm2__c">&#8250;</span></button><ul class="jrcm2 jrcm2--l3">';
      g[1].forEach(function(n){ h+='<li><a href="'+U(n,!!g[2])+'">'+esc(n)+'</a></li>'; });
      h+="</ul></li>";
    });
    h+='</ul></li><li><a href="'+U("Calgary",true)+'">Calgary</a></li>'
      +'<li><a href="'+U("Calgary",true)+'&openhouse=1">Open Houses</a></li>'
      +'<li><a href="/pages/communities">Community Guides</a></li>'
      +'<li><a href="/pages/relocation">Relocation Guide</a></li></ul>';
    return h;
  }
  var CSS=".gh-drop.jrcm{left:0!important;right:auto!important;width:250px!important;padding:10px 0!important;overflow:visible!important;border:1px solid rgba(255,255,255,.10)!important}"
   +".gh-drop.jrcm .jrcm2--l2.is-open,.gh-drop.jrcm .jrcm2--l3.is-open{opacity:1!important;visibility:visible!important;transform:translateX(0)!important}"
   +".gh-drop.jrcm .jrcm2{list-style:none!important;margin:0!important;padding:0!important}"
   +".gh-drop.jrcm .jrcm2 li{position:relative!important;margin:0!important}"
   +".gh-drop.jrcm .jrcm2 a,.gh-drop.jrcm .jrcm2__t{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:10px!important;width:100%!important;box-sizing:border-box!important;padding:10px 22px!important;background:none!important;border:0!important;font-family:inherit!important;font-size:13.5px!important;font-weight:400!important;letter-spacing:.01em!important;text-transform:none!important;text-align:left!important;color:rgba(255,255,255,.8)!important;cursor:pointer!important;transition:color .15s ease,background .15s ease!important}"
   +".gh-drop.jrcm .jrcm2 a:hover,.gh-drop.jrcm .jrcm2__t:hover,.gh-drop.jrcm .jrcm2 a:focus-visible,.gh-drop.jrcm .jrcm2__t:focus-visible{color:#fff!important;background:rgba(255,255,255,.07)!important}"
   +".gh-drop.jrcm .jrcm2__c{opacity:.5!important;font-size:16px!important;line-height:1!important}"
   +".gh-drop.jrcm .jrcm2--l2,.gh-drop.jrcm .jrcm2--l3{position:absolute!important;top:-10px!important;left:100%!important;min-width:216px!important;padding:10px 0!important;opacity:0!important;visibility:hidden!important;transform:translateX(-6px)!important;transition:opacity .16s ease,transform .16s ease!important;z-index:60!important}"
   +".gh-drop.jrcm .jrcm2--l3{max-height:min(72vh,540px)!important;overflow-y:auto!important;overflow-x:hidden!important}"
   +".gh-drop.jrcm .jrcm2--flip{left:auto!important;right:100%!important;transform:translateX(6px)!important}"
   +".gh-drop.jrcm .jrcm2__has:hover>.jrcm2--l2,.gh-drop.jrcm .jrcm2__has:hover>.jrcm2--l3,.gh-drop.jrcm .jrcm2__has:focus-within>.jrcm2--l2,.gh-drop.jrcm .jrcm2__has:focus-within>.jrcm2--l3{opacity:1!important;visibility:visible!important;transform:translateX(0)!important}"
   +".gh-drop.jrcm.jrcm-open{opacity:1!important;visibility:visible!important;transform:none!important;pointer-events:auto!important}"
   +".gh-item.has-drop:focus-within .gh-drop.jrcm{opacity:1!important;visibility:visible!important;transform:none!important;pointer-events:auto!important}"
   +'.gh-drop.jrcm::before{content:"";position:absolute;left:0;right:0;top:-16px;height:16px}'
   +"@media (max-width:900px){.gh-item.has-drop > .gh-drop{display:none!important;max-height:none!important;height:auto!important;overflow:visible!important;position:static!important;transform:none!important}.gh-item.has-drop.exp > .gh-drop{display:block!important;max-height:none!important;height:auto!important}.gh-drop.jrcm{position:static!important;width:auto!important;padding:2px 0 8px!important;box-shadow:none!important;border-radius:0!important}"
   +".gh-drop.jrcm .jrcm2--l2,.gh-drop.jrcm .jrcm2--l3{position:static!important;opacity:1!important;visibility:visible!important;transform:none!important;background:none!important;border:0!important;box-shadow:none!important;max-height:none!important;padding:0 0 0 12px!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;display:none!important}"
   +".gh-drop.jrcm .jrcm2--l2.is-exp{display:block!important}"
   +".gh-drop.jrcm .jrcm2--l3.is-exp{display:grid!important;grid-template-columns:1fr 1fr!important;gap:0 12px!important}"
   +".gh-drop.jrcm .jrcm2__t{font-size:11.5px!important;letter-spacing:.13em!important;text-transform:uppercase!important;color:rgba(255,255,255,.62)!important;pointer-events:auto!important;cursor:pointer!important}"
   +".gh-drop.jrcm .jrcm2__c{display:inline-block!important;opacity:.6!important;transform:rotate(90deg)!important;transition:transform .18s ease!important}"
   +".gh-drop.jrcm .jrcm2__has.is-exp-p > .jrcm2__t .jrcm2__c{transform:rotate(-90deg)!important}"
   +".gh-drop.jrcm .jrcm2 a{padding:11px 10px!important}"
   +".gh-drop.jrcm .jrcm2 a{padding:8px 10px!important}}";
  function init(){
    var a=document.querySelector('a.gh-link[href="/pages/communities"]'); if(!a) return;
    var li=a.closest("li"); if(!li) return;
    var drop=li.querySelector(".gh-drop"); if(!drop) return;
    if(drop.getAttribute("data-jrcm")==="1") return;
    if(!document.getElementById("jrcm-css")){ var s=document.createElement("style"); s.id="jrcm-css"; s.textContent=CSS; document.head.appendChild(s); }
    drop.innerHTML=build(); drop.classList.add("jrcm"); drop.setAttribute("data-jrcm","1");
    /* copy the theme dropdown skin onto the flyouts so colours match the other menus */
    var ref=null, all=document.querySelectorAll(".gh-item.has-drop .gh-drop");
    for(var i=0;i<all.length;i++){ if(all[i]!==drop){ ref=all[i]; break; } }
    if(ref && window.innerWidth > 900){ var rc=getComputedStyle(ref);
      var skin=function(el){ el.style.setProperty("background-color",rc.backgroundColor,"important"); if(rc.backgroundImage&&rc.backgroundImage!=="none") el.style.setProperty("background-image",rc.backgroundImage,"important");
        if(rc.backdropFilter&&rc.backdropFilter!=="none"){ el.style.setProperty("backdrop-filter",rc.backdropFilter,"important"); el.style.setProperty("-webkit-backdrop-filter",rc.backdropFilter,"important"); }
        el.style.setProperty("box-shadow",rc.boxShadow,"important");
        el.style.setProperty("border-radius","12px","important");
        el.style.setProperty("border","1px solid rgba(255,255,255,.10)","important"); };
      [].forEach.call(drop.querySelectorAll(".jrcm2--l2,.jrcm2--l3"),skin);
    }
    /* flip a flyout to the left when it would run past the viewport edge */
    [].forEach.call(drop.querySelectorAll(".jrcm2__has"),function(h){
      var st=null;
      h.addEventListener("mouseenter",function(){ var sub=h.querySelector(":scope > ul"); if(!sub) return;
        clearTimeout(st);
        var sibs=h.parentNode.children;
        for(var k=0;k<sibs.length;k++){ if(sibs[k]!==h){ var o=sibs[k].querySelector(":scope > ul"); if(o) o.classList.remove("is-open"); } }
        sub.classList.remove("jrcm2--flip");
        var r=h.getBoundingClientRect();
        if(r.right+232>window.innerWidth-12) sub.classList.add("jrcm2--flip");
        sub.classList.add("is-open"); });
      h.addEventListener("mouseleave",function(){ var sub=h.querySelector(":scope > ul"); if(!sub) return;
        clearTimeout(st); st=setTimeout(function(){ sub.classList.remove("is-open"); },260); });
    });
    drop.addEventListener("click",function(e){
      if(window.innerWidth>900) return;
      var t=e.target&&e.target.closest?e.target.closest(".jrcm2__t"):null;
      if(!t||!drop.contains(t)) return;
      e.preventDefault(); e.stopPropagation();
      var sub=t.parentNode.querySelector(":scope > ul"); if(!sub) return;
      var open=sub.classList.contains("is-exp");
      var sibs=t.parentNode.parentNode.children;
      for(var k=0;k<sibs.length;k++){ var o=sibs[k].querySelector(":scope > ul");
        if(o){ o.classList.remove("is-exp"); sibs[k].classList.remove("is-exp-p"); } }
      if(!open){ sub.classList.add("is-exp"); t.parentNode.classList.add("is-exp-p"); }
    },false);
    var ct=null;
    var openIt=function(){ clearTimeout(ct); drop.classList.add("jrcm-open"); };
    var closeIt=function(){ clearTimeout(ct); ct=setTimeout(function(){ drop.classList.remove("jrcm-open"); },300); };
    li.addEventListener("mouseenter",openIt); li.addEventListener("mouseleave",closeIt);
    drop.addEventListener("mouseenter",openIt); drop.addEventListener("mouseleave",closeIt);
    document.addEventListener("keydown",function(e){ if(e.key==="Escape"){ clearTimeout(ct); drop.classList.remove("jrcm-open"); } });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init); else init();
  setTimeout(init,500); setTimeout(init,1500); setTimeout(init,3000);
})();

/* ===== JR-SAVED-0902 : Saved Homes / Saved Searches / Account ==============
   Backed by the Shopify App Proxy at /apps/saved -> jasjeet-idx Worker + KV.
   No signing secret and no identity token ever reaches the browser: Shopify
   signs logged_in_customer_id server-side on every proxied request.
   ========================================================================= */
(function () {
  if (window.__JRSAVED) return; window.__JRSAVED = 1;
  var API = '/apps/saved';
  var BOOKING = 'https://calendly.com/jasjeetsinghrealty/private-real-estate-consultation';
  var S = { ready: false, anon: window.JR_CUSTOMER !== true, homes: [], searches: [], hidden: [], prefs: {}, profile: {} };

  function api(path, opts) {
    var o = opts || {}; o.credentials = 'same-origin'; o.cache = 'no-store';
    return fetch(API + path, o).then(function (r) {
      return r.json().catch(function () { return { ok: false }; });
    }).catch(function () { return { ok: false }; });
  }
  function track(n, p) { try { if (window.jrxTrack) window.jrxTrack(n, p || {}); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  var ICO = {
    heart: '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.5-7-9.2A4 4 0 0 1 12 8a4 4 0 0 1 7 2.8C19 15.5 12 20 12 20z"/></svg>',
    bell: '<svg viewBox="0 0 24 24"><path d="M6 9a6 6 0 0 1 12 0c0 4 1.5 5.5 1.5 5.5h-15S6 13 6 9z"/><path d="M10 18a2 2 0 0 0 4 0"/></svg>',
    search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>',
    user: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.4"/><path d="M4.8 19.5a7.2 7.2 0 0 1 14.4 0"/></svg>'
  };

  function css() {
    if (document.getElementById('jrsv-css')) return;
    var s = document.createElement('style'); s.id = 'jrsv-css';
    s.textContent =
      '.jrsv-item > .gh-link{display:inline-flex!important;align-items:center;gap:7px;position:relative}'
      + '.jrsv-ico{display:inline-flex;width:17px;height:17px;flex:none}'
      + '.jrsv-ico svg{width:100%;height:100%;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}'
      + '.jrsv-item.is-on .jrsv-ico svg{fill:#cf1235;stroke:#cf1235}'
      + '.jrsv-count{display:none;min-width:16px;height:16px;padding:0 4px;border-radius:9px;background:#cf1235;color:#fff;font-size:10px;line-height:16px;text-align:center;letter-spacing:0}'
      + '.jrsv-count.on{display:inline-block}'
      + '@media(min-width:901px){.jrsv-label{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}}'
      + '@media(max-width:900px){.jrsv-ico{display:none}}'
      + '.jrsv-ov{position:fixed;inset:0;z-index:10060;background:rgba(8,10,13,.62);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);display:flex;align-items:flex-start;justify-content:center;padding:78px 16px 24px;overflow:auto}'
      + '.jrsv-mod{width:100%;max-width:760px;background-image:linear-gradient(rgb(58,66,76),rgb(45,53,61));border:1px solid rgba(255,255,255,.10);border-radius:12px;box-shadow:rgba(15,19,24,.5) 0 30px 60px;color:#fff;overflow:hidden}'
      + '.jrsv-hd{display:flex;align-items:center;justify-content:space-between;padding:16px 18px;border-bottom:1px solid rgba(255,255,255,.08)}'
      + '.jrsv-hd h2{margin:0;font-family:"Barlow Condensed",sans-serif;font-size:18px;letter-spacing:.14em;text-transform:uppercase;font-weight:600}'
      + '.jrsv-x{background:none;border:0;color:rgba(255,255,255,.7);font-size:22px;line-height:1;cursor:pointer;padding:4px 6px}'
      + '.jrsv-bd{padding:14px 18px 20px;max-height:min(70vh,620px);overflow:auto}'
      + '.jrsv-empty{padding:26px 4px;color:rgba(255,255,255,.66);font-size:14px;line-height:1.5}'
      + '.jrsv-row{display:flex;gap:12px;align-items:center;padding:11px 0;border-bottom:1px solid rgba(255,255,255,.07)}'
      + '.jrsv-row:last-child{border-bottom:0}'
      + '.jrsv-th{width:74px;height:56px;border-radius:8px;object-fit:cover;flex:none;background:rgba(255,255,255,.06)}'
      + '.jrsv-meta{flex:1;min-width:0}'
      + '.jrsv-p{font-family:"Barlow Condensed",sans-serif;font-size:17px;letter-spacing:.04em;font-weight:600}'
      + '.jrsv-a{font-size:13px;color:rgba(255,255,255,.72);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
      + '.jrsv-s{font-size:12px;color:rgba(255,255,255,.5);margin-top:2px}'
      + '.jrsv-act{display:flex;gap:8px;align-items:center;flex:none}'
      + '.jrsv-btn{background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.14);color:#fff;border-radius:8px;padding:7px 11px;font:600 11.5px/1 "Barlow Condensed",sans-serif;letter-spacing:.13em;text-transform:uppercase;cursor:pointer;text-decoration:none;display:inline-block}'
      + '.jrsv-btn:hover{background:rgba(255,255,255,.15)}'
      + '.jrsv-btn--r{background:linear-gradient(160deg,#cf1235,#8e0c24);border-color:transparent}'
      + '.jrsv-sel{background:rgba(0,0,0,.28);border:1px solid rgba(255,255,255,.14);color:#fff;border-radius:8px;padding:6px 8px;font-size:12px}'
      + '.jrsv-fav{position:absolute;top:10px;right:10px;z-index:6;width:34px;height:34px;border-radius:50%;border:1px solid rgba(255,255,255,.28);background:rgba(12,15,19,.55);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:transform .18s ease,background .18s ease}'
      + '.jrsv-fav:hover{transform:scale(1.08);background:rgba(12,15,19,.78)}'
      + '.jrsv-fav svg{width:18px;height:18px;fill:none;stroke:#fff;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}'
      + '.jrsv-fav.is-on svg{fill:#cf1235;stroke:#cf1235}'
      + '.jrsv-gone{display:none!important}'
      + '.jrsv-savebar{display:inline-flex;align-items:center;gap:8px;margin:0 0 0 10px;vertical-align:middle}'
      + '.jrsv-menu{position:absolute;top:calc(100% + 6px);right:0;min-width:222px;background-image:linear-gradient(rgb(58,66,76),rgb(45,53,61));border:1px solid rgba(255,255,255,.10);border-radius:12px;box-shadow:rgba(15,19,24,.5) 0 26px 54px;padding:8px 0;z-index:10040;display:none!important;text-align:left}'
      + '.jrsv-menu.is-open{display:block!important}'
      + '.jrsv-menu a{display:block!important;padding:11px 18px!important;color:rgba(255,255,255,.84)!important;font-size:12.5px!important;line-height:1.3!important;text-decoration:none!important;letter-spacing:.06em!important;text-transform:uppercase!important;font-family:"Barlow Condensed",sans-serif!important;white-space:nowrap!important;background:none!important;border:0!important}'
      + '.jrsv-menu a:hover{background:rgba(255,255,255,.08)!important;color:#fff!important}'
      + '.jrsv-menu hr{border:0;border-top:1px solid rgba(255,255,255,.10);margin:6px 0}'
      + '.jrsv-hide{position:absolute;top:10px;right:52px;z-index:6;width:34px;height:34px;border-radius:50%;border:1px solid rgba(255,255,255,.28);background:rgba(12,15,19,.55);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:transform .18s ease,background .18s ease}'
      + '.jrsv-hide:hover{transform:scale(1.08);background:rgba(12,15,19,.78)}'
      + '.jrsv-hide svg{width:16px;height:16px;fill:none;stroke:#fff;stroke-width:1.9;stroke-linecap:round}'
      + '.jrsv-gate{position:fixed;inset:0;z-index:10080;background:rgba(8,10,13,.55);display:flex;align-items:center;justify-content:center;padding:20px}'
      + '.jrsv-gate__box{position:relative;width:340px;max-width:100%;background-image:linear-gradient(180deg,rgb(27,33,41),rgb(19,24,30));border:1px solid rgba(255,255,255,.12);border-radius:12px;box-shadow:0 34px 80px rgba(0,0,0,.6);color:#fff;padding:22px 22px 18px}'
      + '.jrsv-gate__hd{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 0 18px}'
      + '.jrsv-gate h2{margin:0;font-family:"Barlow Condensed",sans-serif;font-size:21px;line-height:1.1;letter-spacing:.1em;text-transform:uppercase;font-weight:600;color:#fff}'
      + '.jrsv-gate__x{background:none;border:0;color:rgba(255,255,255,.65);font-size:22px;line-height:1;cursor:pointer;padding:0 2px;flex:none}'
      + '.jrsv-gate__x:hover{color:#fff}'
      + '.jrsv-gate__lede{margin:0 0 16px;font-size:13px;line-height:1.55;color:rgba(255,255,255,.70)}'
      + '.jrsv-gate__go{display:block;width:100%;padding:13px 16px;border:0;border-radius:8px;background:#cf1235;color:#fff;font-family:"Barlow Condensed",sans-serif;font-size:15px;letter-spacing:.14em;text-transform:uppercase;font-weight:600;cursor:pointer;transition:background .15s ease}'
      + '.jrsv-gate__go:hover{background:#b30f2d}'
      + '.jrsv-gate__or{display:flex;align-items:center;gap:12px;margin:16px 0;color:rgba(255,255,255,.45);font-size:11.5px;letter-spacing:.14em}'
      + '.jrsv-gate__or::before,.jrsv-gate__or::after{content:"";flex:1;height:1px;background:rgba(255,255,255,.14)}'
      + '.jrsv-gate__alt{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;padding:12px 16px;border:1px solid rgba(255,255,255,.22);border-radius:8px;background:rgba(255,255,255,.04);color:#fff;font-size:13.5px;font-weight:600;cursor:pointer;transition:background .15s ease,border-color .15s ease}'
      + '.jrsv-gate__alt:hover{background:rgba(255,255,255,.10);border-color:rgba(255,255,255,.35)}'
      + '.jrsv-gate__alt svg{width:16px;height:16px;flex:none;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}'
      + '.jrsv-gate__legal{margin:16px 0 0;font-size:11.5px;line-height:1.55;color:rgba(255,255,255,.45);text-align:center}'
      + '.jrsv-gate__legal a{color:rgba(255,255,255,.72);text-decoration:underline}'
      + '@media(max-width:600px){.jrsv-gate__box{width:100%;padding:20px 18px 16px}.jrsv-gate h2{font-size:19px}}'
      + '.jrsv-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:10070;background:linear-gradient(rgb(58,66,76),rgb(45,53,61));border:1px solid rgba(255,255,255,.12);color:#fff;padding:11px 16px;border-radius:10px;font-size:13.5px;box-shadow:0 18px 40px rgba(0,0,0,.4);max-width:90vw}';
    document.head.appendChild(s);
  }

  function toast(msg) {
    var t = document.createElement('div'); t.className = 'jrsv-toast'; t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; }, 2400);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2800);
  }

  function login(intent, backTo) {
    try { sessionStorage.setItem('jrsv_intent', JSON.stringify(intent || null)); } catch (e) {}
    authGate(backTo || (location.pathname + location.search));
  }
  function goLogin(back) { location.href = (window.JR_LOGIN_PATH || '/customer_authentication/login?return_to=') + encodeURIComponent(back); }
  function authGate(back) {
    var old = document.querySelector('.jrsv-gate');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var ov = document.createElement('div');
    ov.className = 'jrsv-gate';
    ov.innerHTML = '<div class="jrsv-gate__box" role="dialog" aria-modal="true" aria-label="Sign up or log in">'
      + '<div class="jrsv-gate__hd"><h2>Sign up or Log in</h2><button type="button" class="jrsv-gate__x" data-gate="no" aria-label="Close">&times;</button></div>'
      + '<p class="jrsv-gate__lede">Save homes, save searches, and choose how often you hear about new Calgary listings.</p>'
      + '<button type="button" class="jrsv-gate__go" data-gate="go">Sign up or Log in</button>'
      + '<p class="jrsv-gate__legal">Secure sign-in on account.jasjeetsingh.ca. By continuing you accept the <a href="/policies/terms-of-service" target="_blank" rel="noopener">Terms of Service</a> and <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</p>'
      + '</div>';
    ov.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-gate]') : null;
      if (t && t.getAttribute('data-gate') === 'go') { goLogin(back); return; }
      if (e.target === ov || (t && t.getAttribute('data-gate') === 'no')) { if (ov.parentNode) ov.parentNode.removeChild(ov); }
    }, false);
    document.addEventListener('keydown', function esc(ev) {
      if (ev.key !== 'Escape') return;
      document.removeEventListener('keydown', esc, false);
      if (ov.parentNode) ov.parentNode.removeChild(ov);
    }, false);
    document.body.appendChild(ov);
    var go = ov.querySelector('.jrsv-gate__go'); if (go) go.focus();
  }
  /* ---------- data ---------- */
  function load() {
    return api('?_=' + Date.now()).then(function (d) {
      S.ready = true;
      S.anon = (d.anon === true) || d.ok !== true;
      S.homes = d.homes || []; S.searches = d.searches || [];
      S.hidden = d.hidden || []; S.prefs = d.prefs || {}; S.profile = d.profile || {};
      paint(); renderDash(); resume(); return S;
    });
  }
  function ensure(fn) { if (S.ready) return fn(); load().then(fn); }
  function isSaved(mls) { for (var i = 0; i < S.homes.length; i++) if (S.homes[i].mls === mls) return true; return false; }

  function saveHome(payload) {
    return api('/home', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (d) {
        if (d && d.ok) {
          if (d.saved) { S.homes.unshift(Object.assign({ at: new Date().toISOString() }, payload)); track('saved_home', { mls: payload.mls, address: payload.address, price: payload.price }); toast('Saved to your homes.'); }
          else { S.homes = S.homes.filter(function (h) { return h.mls !== payload.mls; }); toast('Removed from saved homes.'); }
          paint();
        } else if (d && d.anon) { login({ t: 'home', d: payload }); }
        else { toast('Could not save that just now.'); }
        return d;
      });
  }
  function saveSearch(payload) {
    return api('/search', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (d) {
        if (d && d.ok && d.search) {
          S.searches = S.searches.filter(function (x) { return x.id !== d.search.id; });
          S.searches.unshift(d.search);
          track('saved_search', { name: d.search.name, query: d.search.query, alerts: d.search.freq });
          toast('Search saved. Alerts: ' + d.search.freq + '.');
          paint();
        } else if (d && d.anon) { login({ t: 'search', d: payload }); }
        else { toast('Could not save that search.'); }
        return d;
      });
  }
  function delHome(mls) { return api('/home?mls=' + encodeURIComponent(mls), { method: 'DELETE' }).then(function () { S.homes = S.homes.filter(function (h) { return h.mls !== mls; }); paint(); }); }
  function delSearch(id) { return api('/search?id=' + encodeURIComponent(id), { method: 'DELETE' }).then(function () { S.searches = S.searches.filter(function (x) { return x.id !== id; }); paint(); }); }

  function resume() {
    var raw = null; try { raw = sessionStorage.getItem('jrsv_intent'); } catch (e) {}
    if (!raw) return;
    try { sessionStorage.removeItem('jrsv_intent'); } catch (e) {}
    if (S.anon) return;
    var it = null; try { it = JSON.parse(raw); } catch (e) {}
    if (!it) return;
    if (it.t === 'home') saveHome(it.d);
    else if (it.t === 'hide') hideHome(it.d);
    else if (it.t === 'search') saveSearch(it.d);
  }

  /* ---------- header controls ---------- */
  function mkItem(kind, label, ico) {
    var li = document.createElement('li');
    li.className = 'gh-item jrsv-item';
    li.setAttribute('data-jrsv', kind);
    li.innerHTML = '<a class="gh-link jrsv-link" href="#" role="button"><span class="jrsv-ico">' + ico + '</span>'
      + '<span class="jrsv-label">' + esc(label) + '</span><span class="jrsv-count"></span></a>';
    return li;
  }
  function buildHeader() {
    var nav = document.querySelector('#ghNav'); if (!nav) return;
    if (nav.querySelector('.jrsv-item')) return;
    var anchor = nav.querySelector('.gh-cta');
    var mkIns = function (node) { if (anchor && anchor.parentNode === nav) nav.insertBefore(node, anchor); else nav.appendChild(node); };
    mkIns(mkItem('homes', 'Saved Homes', ICO.heart));
    mkIns(mkItem('searches', 'Saved Searches', ICO.search));
    mkIns(mkItem('alerts', 'Notifications', ICO.bell));
    mkIns(mkItem('account', 'Sign up or Log in', ICO.user));
    nav.addEventListener('click', function (e) {
      var li = e.target && e.target.closest ? e.target.closest('.jrsv-item') : null;
      if (!li || !nav.contains(li)) return;
      e.preventDefault(); e.stopPropagation();
      var k = li.getAttribute('data-jrsv');
      ensure(function () {
        if (k === 'account') {
          if (S.anon) { login(null, '/pages/my-account'); return; }
          location.href = '/pages/my-account';
          return;
        }
        if (S.anon) { login(null, '/pages/my-account#' + k); return; }
        location.href = '/pages/my-account#' + k;
      });
    }, false);
  }
  function paint() {
    var m = { homes: S.homes.length, searches: S.searches.length };
    [].forEach.call(document.querySelectorAll('.jrsv-item'), function (li) {
      var k = li.getAttribute('data-jrsv');
      var c = li.querySelector('.jrsv-count');
      var lab = li.querySelector('.jrsv-label');
      if (k === 'account') {
        if (lab) lab.textContent = S.anon ? 'Sign up or Log in' : 'My Account';
        if (c) c.className = 'jrsv-count';
        if (S.anon) { var mm = li.querySelector('.jrsv-menu'); if (mm && mm.parentNode) mm.parentNode.removeChild(mm); }
        return;
      }
      var n = m[k] || 0;
      if (c) { c.textContent = n; c.className = 'jrsv-count' + (n && !S.anon ? ' on' : ''); }
      li.classList.toggle('is-on', !!n && !S.anon);
    });
    paintFavs();
  }
  function homesHtml() {
    if (!S.homes.length) return '<div class="jrsv-empty">No saved homes yet. Tap the heart on any listing and it will be waiting here on every device you sign in from.</div>';
    return S.homes.map(function (h) {
      return '<div class="jrsv-row">'
        + (h.image ? '<img class="jrsv-th" src="' + esc(h.image) + '" alt="" loading="lazy">' : '<div class="jrsv-th"></div>')
        + '<div class="jrsv-meta"><div class="jrsv-p">' + esc(h.price || '') + '</div>'
        + '<div class="jrsv-a">' + esc(h.address || h.mls) + '</div>'
        + '<div class="jrsv-s">MLS ' + esc(h.mls) + (h.beds ? ' &middot; ' + esc(h.beds) + ' bed' : '') + (h.baths ? ' &middot; ' + esc(h.baths) + ' bath' : '') + '</div></div>'
        + '<div class="jrsv-act">' + (h.url ? '<a class="jrsv-btn jrsv-btn--r" href="' + esc(h.url) + '" target="_blank" rel="noopener">View</a>' : '')
        + '<button class="jrsv-btn" data-act="rmHome" data-id="' + esc(h.mls) + '">Remove</button></div></div>';
    }).join('');
  }
  function qSummary(q) {
    try {
      var p = new URLSearchParams(q); var bits = [];
      if (p.get('cities')) bits.push(p.get('cities'));
      else if (p.get('q')) bits.push(p.get('q'));
      if (p.get('beds') && p.get('beds') !== '0') bits.push(p.get('beds') + '+ bed');
      if (p.get('baths') && p.get('baths') !== '0') bits.push(p.get('baths') + '+ bath');
      var mn = parseInt(p.get('min') || '0', 10), mx = parseInt(p.get('max') || '0', 10);
      if (mn > 0) bits.push('from $' + mn.toLocaleString());
      if (mx > 0 && mx < 90000000) bits.push('to $' + mx.toLocaleString());
      if (p.get('openhouse')) bits.push('open houses');
      return bits.join(' \u00b7 ') || 'All residential';
    } catch (e) { return 'Saved search'; }
  }
  function searchesHtml() {
    if (!S.searches.length) return '<div class="jrsv-empty">No saved searches yet. Run a search, then use Save Search on the results page to get new matches by email.</div>';
    return S.searches.map(function (x) {
      var f = x.freq || 'daily';
      var opts = ['instant', 'daily', 'weekly', 'off'].map(function (o) { return '<option value="' + o + '"' + (o === f ? ' selected' : '') + '>' + (o === 'off' ? 'No alerts' : o.charAt(0).toUpperCase() + o.slice(1)) + '</option>'; }).join('');
      return '<div class="jrsv-row"><div class="jrsv-meta"><div class="jrsv-p">' + esc(x.name) + '</div>'
        + '<div class="jrsv-a">' + esc(qSummary(x.query)) + '</div>'
        + '<div class="jrsv-s">Alerts <select class="jrsv-sel" data-freq="' + esc(x.id) + '">' + opts + '</select></div></div>'
        + '<div class="jrsv-act"><a class="jrsv-btn jrsv-btn--r" href="/pages/property-search?' + esc(x.query) + '">Run</a>'
        + '<button class="jrsv-btn" data-act="rmSearch" data-id="' + esc(x.id) + '">Remove</button></div></div>';
    }).join('');
  }
  /* ---------- listing card hearts ---------- */
  function cardData(card) {
    var url = card.getAttribute('data-card-url') || '';
    var m = url.match(/\/property\/\d+-([A-Za-z0-9]+)-/);
    if (!m) return null;
    var media = card.querySelector('.jhps__card-media');
    var img = card.querySelector('img');
    var price = card.querySelector('.jhps__price');
    var addr = (media && media.getAttribute('aria-label') || '').replace(/^View\s+/i, '');
    if (!addr && img) addr = img.getAttribute('alt') || '';
    var specs = card.querySelectorAll('.jhps__spec');
    var beds = '', baths = '', sqft = '';
    for (var i = 0; i < specs.length; i++) {
      var t = (specs[i].textContent || '').trim();
      if (/bed/i.test(t) && !beds) beds = t.replace(/[^0-9.]/g, '');
      else if (/bath/i.test(t) && !baths) baths = t.replace(/[^0-9.]/g, '');
      else if (/sq/i.test(t) && !sqft) sqft = t.replace(/[^0-9]/g, '');
    }
    return { mls: m[1], url: url, address: addr, price: price ? (price.textContent || '').trim() : '', image: img ? img.getAttribute('src') || '' : '', beds: beds, baths: baths, sqft: sqft };
  }
  function paintFavs() {
    var hset = {};
    if (!S.anon && S.hidden && S.hidden.length) S.hidden.forEach(function (x) { hset[x.mls] = 1; });
    [].forEach.call(document.querySelectorAll('.jrsv-fav'), function (b) {
      var cc = b.closest('article');
      if (cc && hset[b.getAttribute('data-mls')]) { cc.parentNode && cc.parentNode.removeChild(cc); return; }
      var on = !S.anon && isSaved(b.getAttribute('data-mls'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from saved homes' : 'Save this home');
      b.setAttribute('title', on ? 'Saved' : 'Save this home');
    });
  }
  function buildFavs() {
    [].forEach.call(document.querySelectorAll('article.jhps__card'), function (card) {
      var media = card.querySelector('.jhps__card-media'); if (!media) return;
      if (media.querySelector('.jrsv-fav')) return;
      var d = cardData(card); if (!d) return;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'jrsv-fav'; b.setAttribute('data-mls', d.mls);
      b.innerHTML = ICO.heart;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ensure(function () { if (S.anon) { login({ t: 'home', d: d }); return; } saveHome(d); });
      }, false);
      media.appendChild(b);
      var hb = document.createElement('button');
      hb.type = 'button'; hb.className = 'jrsv-hide'; hb.setAttribute('data-mls', d.mls);
      hb.setAttribute('aria-label', 'Hide this home'); hb.setAttribute('title', 'Hide this home');
      hb.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg>';
      hb.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ensure(function () {
          if (S.anon) { login({ t: 'hide', d: d }); return; }
          hideHome(d).then(function () { var c = hb.closest('article'); if (c && c.parentNode) c.parentNode.removeChild(c); toast('Hidden. Manage it under Hidden Homes.'); });
        });
      }, false);
      media.appendChild(hb);
    });
    paintFavs();
  }

  /* ---------- save search ---------- */
  function currentQuery() {
    var p = new URLSearchParams(location.search);
    p.delete('view'); p.delete('page'); p.delete('_');
    return p.toString();
  }
  function defaultName() {
    var p = new URLSearchParams(location.search);
    var where = p.get('cities') || p.get('q') || 'Calgary';
    return String(where).replace(/,\s*AB$/i, '') + ' homes';
  }
  function buildSaveSearch() {
    if (!/\/pages\/property-search/.test(location.pathname)) return;
    if (document.querySelector('.jrsv-savebar')) return;
    var host = null, hs = ['.jhps__result-meta', '.jhps__resultshead', '.jhps__count', '.jps-results-head', '.jhps__toolbar'];
    for (var hi = 0; hi < hs.length; hi++) { var hn = document.querySelector(hs[hi]); if (hn && hn.getBoundingClientRect().height > 0) { host = hn; break; } }
    if (!host) { var c = document.querySelector('article.jhps__card'); host = c && c.parentNode ? c.parentNode.parentNode : null; }
    if (!host) return;
    var wrap = document.createElement('span'); wrap.className = 'jrsv-savebar';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'jrsv-btn jrsv-btn--r'; b.textContent = 'Save Search';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var payload = { name: defaultName(), query: currentQuery(), freq: 'daily', alerts: true };
      ensure(function () { if (S.anon) { login({ t: 'search', d: payload }); return; } saveSearch(payload); });
    }, false);
    wrap.appendChild(b);
    var nx = host.querySelector('.jhps__next-link');
    if (nx) { wrap.style.marginLeft = 'auto'; host.insertBefore(wrap, nx); }
    else if (host.firstChild) host.insertBefore(wrap, host.firstChild);
    else host.appendChild(wrap);
  }



  /* ---------- buyer account area (/pages/my-account) ---------- */
  var NAV = [
    ['profile', 'Edit Profile'],
    ['searches', 'Saved Searches'],
    ['homes', 'Saved Homes'],
    ['hidden', 'Hidden Homes'],
    ['alerts', 'Notification Preferences']
  ];
  var PREFS = [
    ['new_home_alerts', 'New Home Alerts', 'New listings that match your saved searches'],
    ['home_status_updates', 'Home Status Updates', 'Price changes, open houses and status changes on your saved homes'],
    ['weekender', 'The Weekender', 'A weekly email of new listings, open houses and Calgary market insight'],
    ['saved_home_reminder', 'Saved Home Reminder', 'A periodic reminder of the homes you have saved'],
    ['market_intel', 'Market Intel', 'Occasional Calgary market updates and buying or selling guidance']
  ];
  var NAVICO = {
    profile: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.4"/><path d="M4.8 19.5a7.2 7.2 0 0 1 14.4 0"/></svg>',
    searches: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>',
    homes: '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.5-7-9.2A4 4 0 0 1 12 8a4 4 0 0 1 7 2.8C19 15.5 12 20 12 20z"/></svg>',
    hidden: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.4"/><path d="m6 18 12-12"/></svg>',
    alerts: '<svg viewBox="0 0 24 24"><rect x="3.4" y="5.6" width="17.2" height="12.8" rx="2"/><path d="m4 7 8 6 8-6"/></svg>'
  };
  function dashSection() {
    var h = (location.hash || '').replace('#', '');
    for (var i = 0; i < NAV.length; i++) if (NAV[i][0] === h) return h;
    return 'homes';
  }
  function emptyBlock(l1, l2) {
    return '<div class="jrsv-empty2">' + esc(l1) + '<br>' + esc(l2)
      + '<br><a class="jrsv-btn jrsv-btn--r" href="/pages/property-search">Search Homes</a></div>';
  }
  function hiddenHtml() {
    if (!S.hidden.length) return emptyBlock('You have not hidden any homes yet.', 'Hide a listing from search results and it will be kept here.');
    return S.hidden.map(function (x) {
      return '<div class="jrsv-row">'
        + (x.image ? '<img class="jrsv-th" src="' + esc(x.image) + '" alt="" loading="lazy">' : '<div class="jrsv-th"></div>')
        + '<div class="jrsv-meta"><div class="jrsv-p">' + esc(x.price || '') + '</div>'
        + '<div class="jrsv-a">' + esc(x.address || x.mls) + '</div>'
        + '<div class="jrsv-s">MLS ' + esc(x.mls) + '</div></div>'
        + '<div class="jrsv-act"><button class="jrsv-btn" data-act="unhide" data-id="' + esc(x.mls) + '">Unhide</button></div></div>';
    }).join('');
  }
  function prefsHtml() {
    return '<button class="jrsv-unsub" data-act="unsuball">Turn off all notifications</button>'
      + PREFS.map(function (p) {
        var on = S.prefs[p[0]] !== false;
        return '<div class="jrsv-pref"><div><h3>' + esc(p[1]) + '</h3><p>' + esc(p[2]) + '</p></div>'
          + '<button class="jrsv-sw" role="switch" aria-checked="' + (on ? 'true' : 'false') + '" data-pref="' + p[0] + '" aria-label="' + esc(p[1]) + '"></button></div>';
      }).join('')
      + '<p class="jrsv-note">These preferences are stored with your account. Listing alert emails are not switched on yet &mdash; see the note on Saved Searches.</p>';
  }
  function profileHtml() {
    var p = S.profile || {};
    var types = ['Home Buyer', 'Home Seller', 'Buyer &amp; Seller', 'Investor', 'Just Looking'];
    var sel = types.map(function (t) { var pl = t.replace('&amp;', '&'); return '<option value="' + esc(pl) + '"' + (p.userType === pl ? ' selected' : '') + '>' + t + '</option>'; }).join('');
    return '<div class="jrsv-form">'
      + '<div class="jrsv-ro"><strong>Email</strong><span>Managed by your sign-in</span><a href="https://account.jasjeetsingh.ca" target="_blank" rel="noopener">Edit</a></div>'
      + '<div class="jrsv-ro"><strong>Sign-in &amp; security</strong><span>Passkeys, email code</span><a href="https://account.jasjeetsingh.ca" target="_blank" rel="noopener">Edit</a></div>'
      + '<div class="jrsv-hr" style="margin:18px 0"></div>'
      + '<div class="jrsv-fld"><label for="jrsvName">Full Name</label><input id="jrsvName" type="text" value="' + esc(p.name || '') + '" placeholder="Your name"></div>'
      + '<div class="jrsv-fld"><label for="jrsvPhone">Phone</label><input id="jrsvPhone" type="tel" value="' + esc(p.phone || '') + '" placeholder="(403) 000-0000"></div>'
      + '<div class="jrsv-fld"><label for="jrsvType">I am a</label><select id="jrsvType">' + sel + '</select></div>'
      + '<div class="jrsv-fld"><label for="jrsvLoc">Area of interest</label><input id="jrsvLoc" type="text" value="' + esc(p.location || '') + '" placeholder="Calgary, AB"></div>'
      + '<button class="jrsv-btn jrsv-btn--r" data-act="saveProfile">Save Profile</button>'
      + '<p class="jrsv-note">Telling Jasjeet what you are looking for means the homes and alerts you get are actually relevant.</p></div>';
  }
  /* ---------- account panel (shell is server-rendered by templates/page.my-account.liquid) ---------- */
  var TITLES = { profile: 'Edit Profile', searches: 'Saved Searches', homes: 'Saved Homes', hidden: 'Hidden Homes', alerts: 'Notification Preferences' };
  var LEDES = {
    profile: 'Your details, so Jasjeet can help properly.',
    searches: 'Save the searches that matter and Jasjeet keeps an eye on them for you \u2014 new listings, price drops and open houses in the areas you are watching.',
    homes: '',
    hidden: 'Listings you have hidden stay out of your search results. Unhide any of them here.',
    alerts: 'Choose what you hear about, and how often.'
  };
  function panelHtml(sec) {
    if (sec === 'homes') return S.homes.length ? homesHtml() : emptyBlock('You have not saved any homes yet.', 'Tap the heart on any listing and it will be waiting here.');
    if (sec === 'searches') return S.searches.length ? searchesHtml() : emptyBlock('You have not saved any searches yet.', 'Run a search, then use Save Search on the results.');
    if (sec === 'hidden') return hiddenHtml();
    if (sec === 'alerts') return prefsHtml();
    return profileHtml();
  }
  function setPref(k, on) {
    var b = {}; b[k] = on; S.prefs[k] = on;
    api('/prefs', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(b) });
  }
  function saveProfile() {
    var g = function (id) { var e = document.getElementById(id); return e ? e.value : ''; };
    var p = { name: g('jrsvName'), phone: g('jrsvPhone'), userType: g('jrsvType'), location: g('jrsvLoc') };
    api('/profile', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(p) }).then(function (d) {
      if (d && d.ok) { S.profile = d.profile; toast('Profile saved.'); renderDash(); track('profile_updated', { userType: p.userType, location: p.location }); }
      else toast('Could not save that.');
    });
  }
  function hideHome(payload) {
    return api('/hidden', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload) }).then(function (d) {
      if (d && d.ok) { return load(); }
      if (d && d.anon) login({ t: 'hide', d: payload });
      return d;
    });
  }
  function renderDash() {
    var acc = document.getElementById('jrsv-acc');
    if (!acc) return;
    if (S.ready) acc.setAttribute('data-auth', S.anon ? 'out' : 'in');
    var pn = document.getElementById('jrsv-panel');
    if (S.ready && S.anon) {
      if (pn) { pn.innerHTML = ''; pn.removeAttribute('aria-busy'); }
      var n0 = acc.querySelector('[data-jrsv-name]'); if (n0) n0.textContent = '';
      var t0 = acc.querySelector('[data-jrsv-type]'); if (t0) t0.textContent = '';
      return;
    }
    var sec = dashSection();
    acc.setAttribute('data-sec', sec);
    var ti = acc.querySelector('[data-jrsv-title]'); if (ti) ti.textContent = TITLES[sec];
    var le = acc.querySelector('[data-jrsv-lede]'); if (le) le.textContent = LEDES[sec];
    [].forEach.call(acc.querySelectorAll('[data-nav]'), function (a) {
      var on = a.getAttribute('data-nav') === sec;
      a.className = on ? 'is-on' : '';
      if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
    var pr = S.profile || {};
    var nn = acc.querySelector('[data-jrsv-name]');
    if (nn && (pr.name || !nn.textContent.trim())) nn.textContent = pr.name || 'Your account';
    var ty = acc.querySelector('[data-jrsv-type]');
    if (ty && (pr.userType || !ty.textContent.trim())) ty.textContent = pr.userType || 'Home Buyer';
    if (!S.ready || !pn) return;
    pn.innerHTML = panelHtml(sec);
    pn.removeAttribute('aria-busy');
  }
    function hydrateDashboard() {
    var acc = document.getElementById('jrsv-acc');
    if (!acc || acc.getAttribute('data-bound') === '1') return;
    acc.setAttribute('data-bound', '1');
    window.addEventListener('hashchange', renderDash, false);
    acc.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-act],[data-pref]') : null;
      if (!t) return;
      if (t.hasAttribute('data-pref')) {
        e.preventDefault();
        var k = t.getAttribute('data-pref');
        var on = t.getAttribute('aria-checked') !== 'true';
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        setPref(k, on); return;
      }
      var act = t.getAttribute('data-act'), id = t.getAttribute('data-id');
      e.preventDefault();
      if (act === 'rmHome') delHome(id).then(renderDash);
      else if (act === 'rmSearch') delSearch(id).then(renderDash);
      else if (act === 'unhide') api('/hidden?mls=' + encodeURIComponent(id), { method: 'DELETE' }).then(function () { load(); });
      else if (act === 'saveProfile') saveProfile();
      else if (act === 'unsuball') {
        PREFS.forEach(function (p) { S.prefs[p[0]] = false; });
        api('/prefs', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ all: false }) });
        renderDash(); toast('All notifications turned off.');
      }
    }, false);
    acc.addEventListener('change', function (e) {
      var sel = e.target; if (!sel || sel.tagName !== 'SELECT' || !sel.getAttribute('data-freq')) return;
      var id = sel.getAttribute('data-freq'), cur = null;
      for (var i = 0; i < S.searches.length; i++) if (S.searches[i].id === id) cur = S.searches[i];
      if (cur) saveSearch({ id: id, name: cur.name, query: cur.query, freq: sel.value, alerts: sel.value !== 'off' });
    }, false);
    renderDash();
  }

  /* ---------- init ---------- */
  var booted = false;
  function clearAuthState() {
    S.ready = false; S.anon = true;
    S.homes = []; S.searches = []; S.hidden = []; S.prefs = {}; S.profile = {};
    try { sessionStorage.removeItem('jrsv_intent'); } catch (e) {}
    var acc = document.getElementById('jrsv-acc');
    if (acc) acc.setAttribute('data-auth', 'out');
    var pn = document.getElementById('jrsv-panel');
    if (pn) { pn.innerHTML = ''; pn.removeAttribute('aria-busy'); }
    [].forEach.call(document.querySelectorAll('.jrsv-menu'), function (m) { if (m.parentNode) m.parentNode.removeChild(m); });
    paint();
  }
  var authBusy = false, authAt = 0;
  function refreshAuth(force) {
    var now = Date.now();
    if (authBusy || (!force && now - authAt < 2000)) return;
    authBusy = true; authAt = now;
    load().then(function () { authBusy = false; }, function () { authBusy = false; });
  }
  function boot() {
    css(); buildHeader(); buildFavs(); buildSaveSearch(); hydrateDashboard(); paint();
    if (booted) return;
    booted = true;
    refreshAuth(true);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/account/logout"]') : null;
      if (a) { clearAuthState(); return; }
      var li = e.target && e.target.closest ? e.target.closest('a[href*="/account/login"]') : null;
      if (li) { e.preventDefault(); login(null, '/pages/my-account'); }
    }, true);
    window.addEventListener('pagehide', function () { S.ready = false; }, false);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshAuth(true); }, false);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshAuth(false); }, false);
    var mo = new MutationObserver(function () { buildFavs(); buildSaveSearch(); });
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(boot, 900); setTimeout(boot, 2500);
})();
